import { useState } from "react";
import { closeModal, Modal } from "risa-oasis-ui_v2";
import WarningIcon from "../../../../../../svg/warningIcon";

interface OptionsDeleteModalProps {
  modalId: string;
  title: string;
  optionName: string;
  optionType: string;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

const OptionsDeleteModal = ({
  modalId,
  title,
  optionName,
  optionType,
  onConfirm,
  onCancel,
}: OptionsDeleteModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
      closeModal(modalId);
    } catch (error) {
      console.error("Error deleting option:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    closeModal(modalId);
    onCancel();
  };

  return (
    <Modal
      dialogId={modalId}
      onSave={handleConfirm}
      title={title}
      saveButtonText={isDeleting ? "Deleting..." : "Delete"}
      cancelText="Cancel"
      disableSave={isDeleting}
      onClose={handleCancel}
    >
      <div className="flex flex-col items-center justify-center text-sm text-gray-600">
        <WarningIcon />
        <div>
          Are you sure you want to delete the {optionType} option{" "}
          <span className="font-bold">{optionName}</span>?
        </div>
        <div>This action cannot be undone.</div>
      </div>
    </Modal>
  );
};

export default OptionsDeleteModal;
